"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_request_1 = require("graphql-request");

var framework_1 = require("../../core/framework");

var Repository =
/** @class */
function (_super) {
  __extends(Repository, _super);

  function Repository() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Repository.prototype.getProductBySkuId = function (marketId, placeId, skuId) {
    return this.request(graphql_request_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query Menu($input: MenuInput!) {\n          menu(input: $input) {\n            groups {\n              skus {\n                categoryId\n                categoryLangCode\n                currency\n                territoryId\n                skuId\n                depotId\n                sku\n                unit\n                unitSize\n                price\n                imageId\n                imageUrl\n                productId\n                name\n                description\n                langCode\n                quantity\n                brandId\n                brandName\n                strainType\n                categoryName\n                THC\n                CBD\n                thcCbdUnit\n                businessAccountId\n                businessAccountName\n                isActive\n                effects {\n                  type\n                  name\n                  strength\n                }\n              }\n            }\n          }\n        }\n      "], ["\n        query Menu($input: MenuInput!) {\n          menu(input: $input) {\n            groups {\n              skus {\n                categoryId\n                categoryLangCode\n                currency\n                territoryId\n                skuId\n                depotId\n                sku\n                unit\n                unitSize\n                price\n                imageId\n                imageUrl\n                productId\n                name\n                description\n                langCode\n                quantity\n                brandId\n                brandName\n                strainType\n                categoryName\n                THC\n                CBD\n                thcCbdUnit\n                businessAccountId\n                businessAccountName\n                isActive\n                effects {\n                  type\n                  name\n                  strength\n                }\n              }\n            }\n          }\n        }\n      "]))), {
      input: {
        marketId: marketId,
        chosenSkuIds: [skuId],
        placeId: placeId
      }
    });
  };

  Repository.prototype.getMenu = function (variables) {
    return this.request(graphql_request_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        query Menu($input: MenuInput!) {\n          menu(input: $input) {\n            groups {\n              name\n              skus {\n                categoryId\n                currency\n                skuId\n                price\n                imageId\n                imageUrl\n                productId\n                name\n                brandId\n                brandName\n                quantity\n                description\n                effects {\n                  name\n                }\n                attributes {\n                  id\n                  name\n                  value\n                  possibleValues\n                }\n                promotions {\n                  id\n                  promotionId\n                  name\n                  bannerUrl\n                  description\n                  promotionType\n                  amount\n                  percent\n                  loyaltyPoints\n                  giftSkuId\n                }\n              }\n            }\n          }\n        }\n      "], ["\n        query Menu($input: MenuInput!) {\n          menu(input: $input) {\n            groups {\n              name\n              skus {\n                categoryId\n                currency\n                skuId\n                price\n                imageId\n                imageUrl\n                productId\n                name\n                brandId\n                brandName\n                quantity\n                description\n                effects {\n                  name\n                }\n                attributes {\n                  id\n                  name\n                  value\n                  possibleValues\n                }\n                promotions {\n                  id\n                  promotionId\n                  name\n                  bannerUrl\n                  description\n                  promotionType\n                  amount\n                  percent\n                  loyaltyPoints\n                  giftSkuId\n                }\n              }\n            }\n          }\n        }\n      "]))), variables);
  };

  Repository.prototype.getUltraSlimMenu = function (marketId, placeId) {
    return this.request(graphql_request_1.gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        query Menu($input: MenuInput!) {\n          menu(input: $input) {\n            groups {\n              skus {\n                skuId\n              }\n            }\n          }\n        }\n      "], ["\n        query Menu($input: MenuInput!) {\n          menu(input: $input) {\n            groups {\n              skus {\n                skuId\n              }\n            }\n          }\n        }\n      "]))), {
      input: {
        marketId: marketId,
        placeId: placeId
      }
    });
  };

  return Repository;
}(framework_1.RepositoryBase);

exports.default = Repository;
var templateObject_1, templateObject_2, templateObject_3;